import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { editCategoryPost } from "../repositories/storeRep";




const initialState = {
  response: {},
  loading: false,
  error: false,
  errorMsg: "",
};
export const editCategoryData= createAsyncThunk(
  "editCategory",
  async (data, thunkAPI) => {
    const response = await editCategoryPost(data);
    return response;
  }
);
export const editCategorySlice = createSlice({
  name: "editCategory",
  initialState,
  extraReducers: {
    [editCategoryData.pending]: (state) => {
      state.loading = true;
    },
    [editCategoryData.fulfilled]: (state, action) => {
      state.loading = false;

      state.response = action.payload;
      console.log(action.payload);
    },
    [editCategoryData.rejected]: (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMsg = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default editCategorySlice.reducer;
